import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommonService} from "../../../../shared/services/common.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../state/app.state";

@Component({
  selector: 'app-warning-right-panel',
  templateUrl: './warning-right-panel.component.html',
  styleUrls: ['./warning-right-panel.component.css']
})
export class WarningRightPanelComponent implements OnInit, OnDestroy {
  role: any;

  constructor(
    private commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<fromRoot.State>,
  ) {


  }

  ngOnInit() {
    this.commonService.removeAuthenticationToken();
    this.commonService.remove2FAT();
    this.commonService.removeLoginOTPToken();
    this.commonService.removeRegisterOtpToken();
    this.commonService.removeRegisterToken();

  }

  ngOnDestroy() {
  }

}
